import type {
  CreateUpdatePolicyRequestDto,
  GetPoliciesResponseDto,
  PolicyDto,
  RemovePolicyResponseDto,
} from 'shared/dtos/policies.dto';

import { ApiService } from './api.service';

export default class PoliciesService extends ApiService {
  public getPolicies = async (): Promise<GetPoliciesResponseDto> => {
    return await this.get(`/policies`);
  };

  public getPolicy = async (id: number): Promise<PolicyDto> => {
    return await this.get(`/policies/${id}`);
  };

  public createPolicy = async (
    formData: CreateUpdatePolicyRequestDto,
  ): Promise<PolicyDto> => {
    return await this.post(`/policies/`, formData);
  };

  public removePolicy = async (
    id: number,
  ): Promise<RemovePolicyResponseDto> => {
    return await this.remove(`/policies/${id}`);
  };

  public updatePolicy = async (
    id: number,
    formData: CreateUpdatePolicyRequestDto,
  ): Promise<PolicyDto> => {
    return await this.put(`/policies/${id}`, formData);
  };
}
